import { Box, Container, Typography } from "@mui/material";
import AmountSlider from "../../AnimatedSlider";

export function ApplySection() {

  return (
    <Box
      component="section"
      sx={{ bgcolor: "primary.light", py: { xs: 6, md: 8 } }}
    >
      <Container
        maxWidth="lg"
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center",
          justifyContent: "space-between",
          gap: { xs: 4, md: 8 },
        }}
      >
        <Box
          component="img"
          src="https://umsousercontent.com/lib_wfKJyoksALKsfAWv/grojpugyxp9wkdi0.png?w=1200&h=900&fit=max&dpr=2"
          alt="Handshake Illustration"
          sx={{ flex: 1, maxWidth: { xs: "100%", md: 400 }, width: "100%" }}
        />
        <Box
          sx={{
            flex: 1,
            color: "text.primary",
            textAlign: { xs: "center", md: "left" },
          }}
        >
          <Typography variant="h4" fontWeight={700} gutterBottom>
            Same day Interest free Rental Bond Loan
          </Typography>
          <Typography variant="body1" sx={{ mb: 4 }}>
            Get your bond paid now for your new rental place stress-free today
            up to $2000
          </Typography>

          <AmountSlider />
        </Box>
      </Container>
    </Box>
  );
}
